(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-announcement-track]');
      if (!track || track.dataset.duplicated) return;

      track.dataset.duplicated = 'true';

      // Repeat the original set until it's at least as wide as the
      // visible bar (measured fresh here, so this adapts to whatever the
      // real viewport width is) - a single copy narrower than the bar
      // (e.g. short announcement text) would otherwise leave a permanent
      // gap of blank background no matter how the loop-seam math below
      // works out, since there'd never be enough rendered content to
      // cover the full visible width at every point in the animation.
      const containerWidth = this.getBoundingClientRect().width;
      const originalChildren = Array.from(track.children);
      while (track.scrollWidth > 0 && track.scrollWidth < containerWidth) {
        originalChildren.forEach((child) => {
          const repeat = child.cloneNode(true);
          repeat.setAttribute('aria-hidden', 'true');
          track.appendChild(repeat);
        });
      }

      // Duplicate the (possibly now-repeated) full set once more, into
      // the SAME track, so the CSS animation (translateX -50%) loops
      // seamlessly - -50% is relative to the track's own width, so the
      // track itself must become 2x its current content width for that
      // to equal exactly one content-copy's distance. Appending a clone
      // of the whole track as a sibling instead (an earlier version of
      // this) left two independently-animated, single-width tracks that
      // only ever traveled half their own width before snapping back.
      // Cloning avoids rendering the same theme blocks twice via Liquid,
      // which would create duplicate block ids and confuse the theme
      // editor's inline selection.
      Array.from(track.children).forEach((child) => {
        const clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      // track.scrollWidth is now exactly 2x one real content copy (the
      // doubling above), which is exactly the distance the animation's
      // translateX(-50%) covers - so duration = that distance / the
      // merchant's px-per-second setting gives a genuinely constant
      // on-screen speed regardless of how wide the track needed to become
      // to fill this particular screen. Setting this AFTER both
      // duplication passes (rather than deriving it from containerWidth
      // above) is what makes this correct - containerWidth alone doesn't
      // account for the seamless-loop doubling.
      const pxPerSecond = parseFloat(getComputedStyle(this).getPropertyValue('--announcement-px-per-second')) || 60;
      const singleCopyWidth = track.scrollWidth / 2;
      const durationSeconds = singleCopyWidth / pxPerSecond;
      this.style.setProperty('--announcement-speed', `${durationSeconds}s`);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleButtons = document.querySelectorAll('[data-cart-drawer-toggle]');
      this.closeTargets = this.querySelectorAll('[data-cart-drawer-close]');
      this.content = this.querySelector('[data-cart-drawer-content]');

      this.toggleButtons.forEach((button) => {
        button.addEventListener('click', () => this.open());
      });

      this.closeTargets.forEach((target) => {
        target.addEventListener('click', () => this.close());
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    async open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.documentElement.classList.add('cart-drawer-open');
      this.refresh();

      // Pulses the TOTAL (not the subtotal - Subtotal is now the
      // pre-discount figure, see snippets/cart-contents.liquid's doc
      // comment; Total is the actual post-discount charge, the more
      // meaningful number to draw attention to) every time the drawer
      // opens (not tied to whether the price actually changed) - queried
      // fresh when the timer fires, not cached now, since refresh() may
      // still be swapping in new content at this point.
      window.setTimeout(() => {
        const total = this.querySelector('[data-cart-total]');
        if (!total) return;
        total.classList.remove('is-updated');
        void total.offsetWidth;
        total.classList.add('is-updated');
      }, 500);
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('cart-drawer-open');
      window.setTimeout(() => {
        this.hidden = true;
      }, 250);
    }

    // Re-fetches this section's own rendered HTML so the drawer never shows
    // stale contents from whenever the page itself first loaded, regardless
    // of what changed the cart or where. Falls back to leaving whatever's
    // already rendered if the request fails - better than a blank drawer.
    async refresh() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart?section_id=cart-drawer`);
        const html = await response.text();
        const fresh = new DOMParser().parseFromString(html, 'text/html');
        const freshContent = fresh.querySelector('[data-cart-drawer-content]');
        if (freshContent && this.content) {
          this.content.innerHTML = freshContent.innerHTML;
        }
      } catch (error) {
        // Keep the existing content.
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class NavDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleButton = document.querySelector('[data-nav-drawer-toggle]');
      this.closeTargets = this.querySelectorAll('[data-nav-drawer-close]');

      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', () => this.open());
      }

      this.closeTargets.forEach((target) => {
        target.addEventListener('click', () => this.close());
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.toggleButton?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('nav-drawer-open');
    }

    close() {
      this.classList.remove('is-open');
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('nav-drawer-open');
      window.setTimeout(() => {
        this.hidden = true;
      }, 250);
    }
  }

  if (!customElements.get('nav-drawer')) {
    customElements.define('nav-drawer', NavDrawer);
  }

  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header || header.dataset.stickyBound) return;
    header.dataset.stickyBound = 'true';

    // The hidden state moves the header by --header-height (not a fixed
    // value), so it needs to reflect the header's real rendered height -
    // set on load and whenever that height could change (e.g. rotating a
    // phone, or the browser chrome resizing the viewport).
    function setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    const threshold = 5;
    let lastScrollY = window.scrollY;
    let ticking = false;

    // Compares each frame only against the immediately preceding one (rather
    // than freezing an anchor point until a threshold is crossed) - simpler
    // and more predictable than the previous "anchor" approach, and reacts
    // to an upward scroll immediately at any position on the page.
    // The try/finally guarantees `ticking` always resets even if something
    // above it throws - otherwise a single uncaught exception on one frame
    // would leave `ticking` stuck `true` forever, silently freezing every
    // future scroll update (including the unconditional top-of-page rule)
    // with no visible error.
    function update() {
      try {
        const currentScrollY = window.scrollY;
        const delta = currentScrollY - lastScrollY;

        if (currentScrollY <= 0) {
          header.classList.remove('is-hidden');
        } else if (delta > threshold) {
          header.classList.add('is-hidden');
        } else if (delta < -threshold) {
          header.classList.remove('is-hidden');
        }

        lastScrollY = currentScrollY;
      } finally {
        ticking = false;
      }
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  initStickyHeader();

  // The theme editor replaces section DOM whenever a setting changes, which
  // would otherwise leave the listener above bound to a detached, stale
  // element. Re-run on every section reload - the dataset guard prevents
  // double-binding the same live element.
  document.addEventListener('shopify:section:load', initStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // See sections/media-carousel.liquid for these shared singletons/module -
  // defined identically (guarded) there, here, and in
  // sections/media-text.liquid so all three compile in any order.
  // TendedAudioCoordinator: only one video's audio active across the
  // whole page at a time. TendedPauseCoordinator: a separate, stricter
  // rule - only one video PLAYING at all, anywhere on the site, no
  // exceptions (a paused video is always silent, but a silent video isn't
  // necessarily paused, which is why these are two coordinators, not
  // one). TendedVideoUX: shared play/pause-icon, buffer-bar, and spinner
  // wiring for snippets/video-controls.liquid's markup.
  window.TendedAudioCoordinator = window.TendedAudioCoordinator || {
    active: null,
    activate(video, deactivate) {
      if (this.active && this.active.video !== video) {
        this.active.deactivate();
      }
      this.active = { video, deactivate };
    },
  };

  window.TendedPauseCoordinator = window.TendedPauseCoordinator || {
    active: null,
    activate(video) {
      if (this.active && this.active !== video && !this.active.paused) {
        this.active.pause();
      }
      this.active = video;
    },
  };

  window.TendedVideoUX = window.TendedVideoUX || {
    wireVideo(video, wrapper) {
      this.setupPlayPauseIcon(video, wrapper);
      this.setupBufferBar(video, wrapper);
      this.setupSpinner(video, wrapper);
      this.registerForPauseCoordination(video);
    },

    setupPlayPauseIcon(video, wrapper) {
      const button = wrapper.querySelector('[data-video-play-button]');
      if (!button) return;

      video.addEventListener('play', () => button.classList.add('is-hidden'));
      video.addEventListener('pause', () => button.classList.remove('is-hidden'));
    },

    setupBufferBar(video, wrapper) {
      const bar = wrapper.querySelector('[data-video-buffer-bar]');
      if (!bar) return;

      const fill = bar.querySelector('[data-video-buffer-fill]');
      const FULLY_BUFFERED_THRESHOLD = 0.995;

      const bufferedRatio = () => {
        if (!video.buffered.length || !video.duration) return 0;
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        return Math.min(1, bufferedEnd / video.duration);
      };

      const updateFill = () => {
        const ratio = bufferedRatio();
        if (fill) fill.style.width = `${ratio * 100}%`;
        bar.classList.toggle('is-visible', ratio < FULLY_BUFFERED_THRESHOLD);
      };

      const markReceiving = () => {
        bar.classList.remove('is-stalled');
        updateFill();
      };

      video.addEventListener('progress', markReceiving);
      video.addEventListener('waiting', () => bar.classList.add('is-stalled'));
      video.addEventListener('canplay', markReceiving);

      updateFill();
    },

    setupSpinner(video, wrapper) {
      const spinner = wrapper.querySelector('[data-video-spinner]');
      if (!spinner) return;

      video.addEventListener('waiting', () => spinner.classList.add('is-visible'));
      video.addEventListener('playing', () => spinner.classList.remove('is-visible'));
      video.addEventListener('pause', () => spinner.classList.remove('is-visible'));
    },

    registerForPauseCoordination(video) {
      video.addEventListener('play', () => {
        window.TendedPauseCoordinator.activate(video);
      });
    },
  };

  class HeroSection extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-hero-video]');
      if (!this.video) return;

      const wrapper = this.querySelector('.hero__media');
      if (wrapper) window.TendedVideoUX.wireVideo(this.video, wrapper);

      // Whole-tile click delegation, not a listener on the button/video
      // individually - deliberately at the outermost element (there's no
      // dragging anywhere in this section, unlike the carousel, so there's
      // no setPointerCapture retargeting risk that would require reading
      // downTarget before capture; a plain 'click' listener works
      // identically for mouse, touch, and keyboard activation of the
      // button here). The one exclusion is the CTA link - it needs to
      // just navigate, not also toggle the video.
      this.addEventListener('click', (event) => {
        if (event.target.closest('.hero__button')) return;

        if (!this.video.dataset.mediaLoaded) {
          this.startVideo();
        } else {
          this.togglePlayback();
        }
      });
    }

    // The click-to-play "start" gesture - promotes the deferred source
    // (nothing has loaded/downloaded before this point), plays, and
    // unmutes (a harmless no-op if this particular file has no audio
    // track) in one action. The play icon itself is never removed from
    // the DOM (see window.TendedVideoUX.setupPlayPauseIcon()) - it just
    // hides once the video's native 'play' event fires, same as any
    // later pause/resume.
    startVideo() {
      this.video.dataset.mediaLoaded = 'true';

      this.video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      this.video.preload = 'auto';
      this.video.load();
      this.video.play().catch(() => {
        // Autoplay policy can still reject this in rare edge cases even
        // for a user-initiated call - the poster stays visible either way.
      });

      this.video.muted = false;
      window.TendedAudioCoordinator.activate(this.video, () => {
        this.video.muted = true;
      });
    }

    // Play/pause only, not mute - same model as the carousel's
    // togglePlayback(). Pausing already silences the video regardless of
    // its muted flag, so there's no separate mute gesture once playing.
    togglePlayback() {
      if (this.video.paused) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    }
  }

  if (!customElements.get('hero-section')) {
    customElements.define('hero-section', HeroSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-carousel"] && !Shopify.designMode) return;
  try {
    
  // Shared across sections/media-carousel.liquid and sections/media-text.liquid
  // so that unmuting a video in either one mutes whatever was previously
  // playing audio in the other - only one video across the whole page may
  // have audio active at a time. Guarded so it's safe if this identical
  // block ends up compiled into the page more than once.
  window.TendedAudioCoordinator = window.TendedAudioCoordinator || {
    active: null,
    activate(video, deactivate) {
      if (this.active && this.active.video !== video) {
        this.active.deactivate();
      }
      this.active = { video, deactivate };
    },
  };

  // Site-wide "only one video plays at a time, no exceptions" - a
  // separate rule from TendedAudioCoordinator above, not merged into it:
  // a paused video is always silent, but a silent video isn't
  // necessarily paused (this carousel's own decorative, always-muted
  // autoplay tiles are exactly that case - no audio involved at all, yet
  // still subject to this rule). Guarded/duplicated the same way across
  // every video-bearing section - see window.TendedVideoUX below.
  window.TendedPauseCoordinator = window.TendedPauseCoordinator || {
    active: null,
    activate(video) {
      if (this.active && this.active !== video && !this.active.paused) {
        this.active.pause();
      }
      this.active = video;
    },
  };

  // Shared UI wiring for every <video> on the site (this carousel, the
  // hero, media-text) - one module instead of three independently
  // drifting copies of the same play/pause-icon, buffer-bar, and spinner
  // logic. Expects snippets/video-controls.liquid's markup rendered as
  // siblings of the <video>, inside the same positioned wrapper passed
  // in here.
  window.TendedVideoUX = window.TendedVideoUX || {
    // Wires all shared behavior for one <video> + its controls wrapper in
    // a single call: play/pause icon visibility, the debug buffer bar,
    // the user-facing loading spinner, and site-wide pause coordination.
    // Safe to call once per video, once its controls markup exists.
    wireVideo(video, wrapper) {
      this.setupPlayPauseIcon(video, wrapper);
      this.setupBufferBar(video, wrapper);
      this.setupSpinner(video, wrapper);
      this.registerForPauseCoordination(video);
    },

    // The play icon is a persistent element (never removed from the DOM
    // - see snippets/video-controls.liquid), shown/hidden purely by
    // listening to the video's own native 'play'/'pause' events rather
    // than tracking state manually at every call site that might pause a
    // video. That's deliberate: it's what makes the icon reappear
    // correctly no matter WHAT paused the video - a manual tap, an
    // auto-pause-on-exit trigger, or TendedPauseCoordinator silencing it
    // in favor of a different video started elsewhere on the page -
    // instead of only the specific code paths remembered to update it.
    // Defaults to visible (matches a freshly-created <video>'s real
    // .paused === true starting state), so it's also correctly shown
    // before a click-to-play video has ever been started at all.
    setupPlayPauseIcon(video, wrapper) {
      const button = wrapper.querySelector('[data-video-play-button]');
      if (!button) return;

      video.addEventListener('play', () => button.classList.add('is-hidden'));
      video.addEventListener('pause', () => button.classList.remove('is-hidden'));
    },

    // Debug-only (settings.show_buffer_bar, Theme settings > Debugging) -
    // snippets/video-controls.liquid only renders this element at all
    // when that setting is on, so this silently no-ops otherwise (the
    // querySelector below finds nothing). Thin native-buffer indicator:
    // green while data is actively arriving, red while genuinely
    // stalled, hidden again once nearly fully buffered.
    setupBufferBar(video, wrapper) {
      const bar = wrapper.querySelector('[data-video-buffer-bar]');
      if (!bar) return;

      const fill = bar.querySelector('[data-video-buffer-fill]');
      const FULLY_BUFFERED_THRESHOLD = 0.995;

      const bufferedRatio = () => {
        if (!video.buffered.length || !video.duration) return 0;
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        return Math.min(1, bufferedEnd / video.duration);
      };

      const updateFill = () => {
        const ratio = bufferedRatio();
        if (fill) fill.style.width = `${ratio * 100}%`;
        bar.classList.toggle('is-visible', ratio < FULLY_BUFFERED_THRESHOLD);
      };

      const markReceiving = () => {
        bar.classList.remove('is-stalled');
        updateFill();
      };

      video.addEventListener('progress', markReceiving);
      video.addEventListener('waiting', () => bar.classList.add('is-stalled'));
      // 'canplay' also clears the stalled color, not just 'progress' -
      // covers the case where playback recovers and resumes without a
      // 'progress' event happening to fire in that same tick.
      video.addEventListener('canplay', markReceiving);

      updateFill();
    },

    // User-facing (always on, not gated by settings.show_buffer_bar -
    // this is for visitors, the buffer bar above is for developers).
    // Shows only while the video is actively trying to play but blocked
    // on data (native 'waiting'), hides once playback genuinely resumes
    // ('playing') - never shown just because the video is paused.
    setupSpinner(video, wrapper) {
      const spinner = wrapper.querySelector('[data-video-spinner]');
      if (!spinner) return;

      video.addEventListener('waiting', () => spinner.classList.add('is-visible'));
      video.addEventListener('playing', () => spinner.classList.remove('is-visible'));
      video.addEventListener('pause', () => spinner.classList.remove('is-visible'));
    },

    // See window.TendedPauseCoordinator above - every video that calls
    // this becomes subject to the site-wide "only one video plays at a
    // time" rule the instant it actually starts playing, regardless of
    // what triggered that (a click, an autoplay-on-scroll-into-view,
    // tap-to-resume, anything).
    registerForPauseCoordination(video) {
      video.addEventListener('play', () => {
        window.TendedPauseCoordinator.activate(video);
      });
    },
  };

  class MediaCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track || this.track.dataset.duplicated) return;

      this.track.dataset.duplicated = 'true';

      this.originalChildren = Array.from(this.track.children);
      this.mediaObservers = [];
      this.wiredVideos = new WeakSet();
      this.keyboardVideos = new WeakSet();
      this.rebuildTrack();

      this.offset = 0;
      this.lastFrameTime = null;
      this.paused = false;
      this.resumeTimer = null;
      this.dragging = false;
      this.activeAudioVideo = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Play/pause toggling is handled inside setupDrag()'s click listener,
      // not a separate method - it needs the same tap-vs-drag `moved`
      // state that lives in that closure.
      this.setupDrag();
      this.setupArrows();
      this.setupIntersectionAutoPause();
      this.setupSectionExitAutoPause();
      this.startLoop();

      // Per-item, visibility-triggered loading - NOT a blanket "load
      // everything on window 'load'" (that was the previous approach, and
      // it was a real problem: every media_carousel_item block's real src
      // is withheld from the initial HTML - see
      // blocks/media_carousel_item.liquid - specifically so nothing
      // fetches before this point, but firing ALL of them at once on load
      // meant every video's full file (not just its poster) downloaded
      // immediately regardless of whether it was ever scrolled to. Worse,
      // since the cloning above duplicates every item at least once for
      // the seamless-loop effect, and querySelectorAll('[data-carousel-media]')
      // matches the clones too, each video's real source was being
      // fetched TWICE, concurrently, close enough together that neither
      // request could be served from the other's HTTP cache - measured on
      // a real page as literally double the transfer size per video, and
      // competing directly with the page's actual LCP request on mobile.
      //
      // Loading each item only once it actually scrolls into the page
      // viewport (default root: null - deliberately NOT root: this, which
      // was tried first and doesn't work here: IntersectionObserver
      // reported entries as fully intersecting even while the whole
      // carousel sat far below the fold, since rootBounds for a
      // non-scrolled-past root element isn't clipped against the outer
      // page viewport the way you'd expect - confirmed via direct
      // instrumentation. root: null uses the browser viewport directly,
      // the same basis setupSectionExitAutoPause() below already relies on)
      // fixes both problems at once: only on-screen items ever pull their
      // full file, and since clones become visible at different times
      // than their originals, the first copy has normally already
      // finished downloading (and is sitting in HTTP cache) by the time
      // its clone scrolls into view later - no separate dedupe-by-source
      // logic needed. A small horizontal rootMargin gives a lead buffer so
      // there's no visible pop from poster to real content mid-scroll.
      // Applies identically on desktop and mobile - no special-casing.
      //
      // Posters are unaffected by any of this - see
      // blocks/media_carousel_item.liquid's <video poster="..."> - that
      // attribute was never deferred and loads eagerly exactly as before.
      this.setupLazyMedia();
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.getBoundingClientRect().width;
        if (width === this.measuredWidth) return;
        this.mediaObservers.forEach((observer) => observer.disconnect());
        this.mediaObservers = [];
        this.rebuildTrack();
        this.setupLazyMedia();
        this.render();
      });
      this.resizeObserver.observe(this);
    }

    rebuildTrack() {
      // Keep original nodes (and their playback state); regenerate only copies.
      Array.from(this.track.children).forEach((child) => {
        if (!this.originalChildren.includes(child)) {
          child.querySelectorAll('video').forEach((video) => {
            video.pause();
            if (video === this.activeAudioVideo) {
              this.setAudioActive(video, false);
              this.activeAudioVideo = null;
            }
          });
          child.remove();
        }
      });
      const originals = this.originalChildren.flatMap((child) =>
        Array.from(child.querySelectorAll('.media-carousel__item'))
      );
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const period = originals.reduce((sum, item) => sum + item.getBoundingClientRect().width + gap, 0);
      this.measuredWidth = this.getBoundingClientRect().width;
      this.singleSetWidth = period;
      this.loopTravelWidth = period * Math.max(1, Math.ceil(this.measuredWidth / period));
      if (!originals.length || period <= 0) return;
      // Each complete copy includes its trailing gap. Never infer the
      // period by halving scrollWidth: the final trailing gap is absent.
      const copies = Math.ceil(this.measuredWidth / period) + 1;
      for (let copy = 0; copy < copies; copy++) {
        this.originalChildren.forEach((child) => {
          const clone = child.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          clone.removeAttribute('id');
          clone.querySelectorAll('button, a, video').forEach((node) => node.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('[data-media-loaded]').forEach((node) => node.removeAttribute('data-media-loaded'));
          clone.querySelectorAll('img[data-carousel-media]').forEach((image) => {
            image.removeAttribute('src');
            image.removeAttribute('srcset');
          });
          clone.querySelectorAll('video').forEach((video) => {
            video.preload = 'none';
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          });
          clone.querySelectorAll('[data-video-play-button]').forEach((button) => button.classList.remove('is-hidden'));
          this.track.appendChild(clone);
        });
      }
      // Let existing visibility observers track the refreshed video copies.
      this.videoExitObserver?.disconnect();
      if (this.videoExitObserver) this.querySelectorAll('video').forEach((video) => this.videoExitObserver.observe(video));
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.rafId);
      window.clearTimeout(this.resumeTimer);
      this.resizeObserver?.disconnect();
      this.mediaObservers?.forEach((observer) => observer.disconnect());
      this.videoExitObserver?.disconnect();
      this.sectionExitObserver?.disconnect();
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    setupLazyMedia() {
      const items = Array.from(this.querySelectorAll('[data-carousel-media]'));
      if (!items.length) return;

      const imageItems = items.filter((el) => el.tagName === 'IMG');
      const videoItems = items.filter((el) => el.tagName === 'VIDEO');

      // Images are unaffected by settings.click_to_play (that setting is
      // video-specific, per its own info text) - always visibility-lazy.
      this.observeForLoad(imageItems, (el) => this.loadImage(el));

      // Every video gets the shared play/pause icon, buffer bar, and
      // spinner wired up unconditionally - even a non-click_to_play,
      // autoplaying tile needs the icon so it can reappear if something
      // pauses it later (see window.TendedVideoUX above).
      videoItems.forEach((video) => {
        const wrapper = video.closest('.media-carousel__item');
        if (wrapper && !this.wiredVideos.has(video)) {
          window.TendedVideoUX.wireVideo(video, wrapper);
          this.wiredVideos.add(video);
        }
      });

      if (this.dataset.clickToPlay === 'true') {
        // No IntersectionObserver at all for videos in this mode - the
        // whole point is that NOTHING is requested/loaded until the
        // visitor explicitly taps play (see setupPlayButtons() below),
        // not "loads a little later than usual".
        this.setupPlayButtons(videoItems);
      } else {
        this.observeForLoad(videoItems, (el) => this.loadVideo(el));
      }
    }

    // Shared visibility-triggered loading, used for images always and for
    // videos only when click_to_play is off (the default - see
    // setupLazyMedia() above). Loading each item only once it actually
    // scrolls into the page viewport (default root: null - deliberately
    // NOT root: this, which was tried first and doesn't work here:
    // IntersectionObserver reported entries as fully intersecting even
    // while the whole carousel sat far below the fold, since rootBounds
    // for a non-scrolled-past root element isn't clipped against the
    // outer page viewport the way you'd expect - confirmed via direct
    // instrumentation. root: null uses the browser viewport directly, the
    // same basis setupSectionExitAutoPause() below already relies on) avoids
    // downloading every item's full file regardless of whether it was
    // ever scrolled to, and since clones become visible at different
    // times than their originals, the first copy has normally already
    // finished downloading (and is sitting in HTTP cache) by the time its
    // clone scrolls into view later - no separate dedupe-by-source logic
    // needed. A small horizontal rootMargin gives a lead buffer so
    // there's no visible pop from poster to real content mid-scroll.
    // Applies identically on desktop and mobile - no special-casing.
    observeForLoad(elements, loadFn) {
      if (!elements.length) return;

      if (!('IntersectionObserver' in window)) {
        // No lazy-loading support at all - fall back to loading
        // everything immediately rather than never loading it.
        elements.forEach(loadFn);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadFn(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 200px 0px 200px', threshold: 0 }
      );

      this.mediaObservers.push(observer);
      elements.forEach((el) => observer.observe(el));
    }

    loadImage(el) {
      if (el.dataset.mediaLoaded) return;
      el.dataset.mediaLoaded = 'true';
      if (el.dataset.srcset) el.srcset = el.dataset.srcset;
      if (el.dataset.src) el.src = el.dataset.src;
    }

    // The one path that actually requests/loads a video's real data -
    // called from observeForLoad() above (visibility-triggered, the
    // default) AND from setupPlayButtons() below (click-triggered, when
    // settings.click_to_play is on) - either way funnels through the same
    // HLS rendition cap, so a merchant enabling click-to-play still gets
    // that benefit, not a separate/forgotten code path.
    loadVideo(el) {
      if (el.dataset.mediaLoaded) return;
      el.dataset.mediaLoaded = 'true';

      const sources = Array.from(el.querySelectorAll('source[data-src]'));
      const hlsSource = sources.find((source) => source.type === 'application/x-mpegURL');
      // The MP4 fallback (for browsers that don't pick HLS at all) keeps
      // its original behavior unchanged - Shopify's video.sources doesn't
      // expose smaller MP4 renditions, only this single full-resolution
      // original, so there's nothing smaller to cap it to from here.
      sources
        .filter((source) => source !== hlsSource)
        .forEach((source) => {
          source.src = source.dataset.src;
        });

      const finishLoad = () => {
        el.preload = 'auto';
        el.load();
        // Explicit here rather than relying on the `autoplay` attribute -
        // there isn't one on these videos at all (see
        // blocks/media_carousel_item.liquid), specifically so nothing
        // fetches before this point. This is what actually starts
        // playback once the real src is in place.
        el.play().catch(() => {
          // Autoplay can still be blocked by browser policy even for a
          // muted video in some edge cases - the poster image stays
          // visible either way, so there's nothing more to do here.
        });
      };

      if (!hlsSource) {
        finishLoad();
        return;
      }

      // Cap which HLS rendition actually gets used, rather than handing
      // the browser the ABR master playlist and letting its own
      // heuristics escalate quality mid-playback - measured on a real
      // page, that escalation pulls individual 1080p segments over
      // 1.3MB EACH for a ~225px-wide, always-muted decorative tile, with
      // no upper bound. Fetching the master here and picking a rendition
      // ourselves, sized to what this tile can actually show, avoids that
      // entirely while still degrading gracefully (see
      // pickCappedHlsRendition() below) to today's master-playlist
      // behavior if anything about this fails.
      const item = el.closest('.media-carousel__item');
      const renderedWidth = item ? item.getBoundingClientRect().width : 400;
      // Capped at 2x - full device pixel ratio on a 3x+ display would
      // demand more resolution than these renditions offer anyway (the
      // ladder tops out around 612px wide), and isn't worth it for a
      // small muted background tile regardless.
      const targetWidth = renderedWidth * Math.min(window.devicePixelRatio || 1, 2);

      this.pickCappedHlsRendition(hlsSource.dataset.src, targetWidth).then((resolvedUrl) => {
        hlsSource.src = resolvedUrl || hlsSource.dataset.src;
        finishLoad();
      });
    }

    // Fetches the HLS master playlist (a small text file, same origin as
    // the page) and picks the smallest rendition whose native width still
    // covers targetWidth, returning that rendition's own (independently
    // playable) manifest URL directly - bypassing the browser's native
    // ABR ladder entirely rather than trying to constrain it. Never
    // rejects - resolves null on ANY failure (bad response, unexpected
    // format, network error) so the caller can unconditionally fall back
    // to today's master-playlist behavior without a separate .catch().
    async pickCappedHlsRendition(masterUrl, targetWidth) {
      try {
        const absoluteMasterUrl = new URL(masterUrl, window.location.href).href;
        const response = await fetch(absoluteMasterUrl);
        if (!response.ok) return null;

        const text = await response.text();
        const lines = text.split('\n').map((line) => line.trim());

        // Standard #EXT-X-STREAM-INF syntax: the attributes line (with a
        // RESOLUTION=WxH attribute) is immediately followed by the
        // rendition's own manifest URI on the next line.
        const renditions = [];
        lines.forEach((line, index) => {
          if (!line.startsWith('#EXT-X-STREAM-INF')) return;
          const match = line.match(/RESOLUTION=(\d+)x(\d+)/);
          const uri = lines[index + 1];
          if (match && uri && !uri.startsWith('#')) {
            renditions.push({ width: parseInt(match[1], 10), uri });
          }
        });
        if (!renditions.length) return null;

        renditions.sort((a, b) => a.width - b.width);
        const covering = renditions.find((rendition) => rendition.width >= targetWidth);
        // If nothing covers the target (a merchant-configured tile larger
        // than even the biggest available rendition), fall back to the
        // largest one available rather than deliberately serving
        // something under-resolution.
        const chosen = covering || renditions[renditions.length - 1];

        return new URL(chosen.uri, absoluteMasterUrl).href;
      } catch (error) {
        return null;
      }
    }

    // settings.click_to_play mode: nothing loads/downloads until the
    // visitor starts a video (see startVideo() below) instead of
    // auto-loading on visibility. The actual pointer-driven (mouse/touch)
    // start gesture is handled uniformly with every other tap in
    // setupDrag()'s endDrag, covering the whole tile, not just the play
    // icon (see snippets/video-controls.liquid). This wires only the
    // keyboard path: a focused button still needs to respond to
    // Enter/Space on its own, since keyboard activation never fires
    // pointerdown/pointerup at all, so it can't go through endDrag.
    // Deliberately keydown, not 'click' - a native click (which
    // Enter/Space would also trigger by default) would double-fire
    // alongside endDrag for touch, where the click still lands on this
    // button correctly (touch gets implicit pointer capture to its
    // original target, unlike mouse - see the capture comment in
    // setupDrag()); preventDefault() below stops that native click from
    // ever being dispatched.
    setupPlayButtons(videoItems) {
      videoItems.forEach((video) => {
        const item = video.closest('.media-carousel__item');
        const button = item ? item.querySelector('[data-video-play-button]') : null;
        if (!button || this.keyboardVideos.has(video)) return;
        this.keyboardVideos.add(video);

        button.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (!video.dataset.mediaLoaded) {
            this.startVideo(video);
          } else {
            this.togglePlayback(video);
          }
        });
      });
    }

    // The click-to-play "start" gesture, shared by the pointer path
    // (endDrag, covering the whole tile - see setupDrag()) and the
    // keyboard path (setupPlayButtons() above). Loads the video (funnels
    // into the same loadVideo() every other path uses, including the HLS
    // rendition cap) and unmutes it - the one deliberate action that
    // gains audio. The play icon itself is never removed from the DOM
    // (see window.TendedVideoUX.setupPlayPauseIcon()) - it just hides
    // once the video's native 'play' event fires, same as every other
    // pause/resume.
    startVideo(video) {
      this.loadVideo(video);
      this.activateAudio(video);
    }

    // Folds an unbounded offset (grows without limit during continuous
    // auto-play; can swing either direction from a drag) into (-width,
    // 0] - the narrow range that's actually backed by rendered content.
    // Content repeats every `width` px, so this is seamless regardless of
    // how large the input is or which direction it came from.
    wrap(value, width) {
      if (!width || !Number.isFinite(width)) return 0;
      let m = value % width;
      if (m > 0) m -= width;
      return m;
    }

    render() {
      this.track.style.transform = `translateX(${this.wrap(this.offset, this.singleSetWidth)}px)`;
    }

    startLoop() {
      if (this.prefersReducedMotion) {
        this.render();
        return;
      }

      const step = (now) => {
        if (this.lastFrameTime === null) this.lastFrameTime = now;
        const dt = now - this.lastFrameTime;
        this.lastFrameTime = now;

        if (!this.paused && !this.dragging) {
          const speedSeconds = parseFloat(getComputedStyle(this).getPropertyValue('--carousel-speed')) || 20;
          const pxPerMs = this.loopTravelWidth / (speedSeconds * 1000);
          this.offset -= pxPerMs * dt;
          this.render();
        }

        this.rafId = requestAnimationFrame(step);
      };

      this.rafId = requestAnimationFrame(step);
    }

    // Pauses auto-advance for the configured delay, then resumes from the current offset -
    // never resets, never "catches up" the paused duration. Each new
    // interaction (another drag, another arrow click) restarts the delay
    // countdown rather than stacking/ignoring it.
    pauseThenResume() {
      this.paused = true;
      if (this.resumeTimer) window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(() => {
        this.paused = false;
        // Reset the frame-timing reference, not just the paused flag -
        // otherwise the next frame's dt would include the full pause
        // and jump the offset by that much distance in one frame.
        this.lastFrameTime = null;
        this.resumeTimer = null;
      }, Math.max(0, Math.min(60, Number(this.dataset.resumeDelay) || 0)) * 1000);
    }

    setupDrag() {
      let pointerId = null;
      let startX = 0;
      let startOffset = 0;
      let moved = 0;
      let downTarget = null;

      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startOffset = this.offset;
        moved = 0;
        // Captured here, before setPointerCapture below - once the track
        // has pointer capture, every subsequent event for this pointer
        // (including the eventual `click`) gets retargeted to the
        // capturing element itself, not whatever the cursor is actually
        // over. Touch doesn't hit this - a touch pointer already gets
        // *implicit* capture to whatever it started on, so this explicit
        // call changes nothing there. Mouse has no such implicit capture,
        // so this explicit capture is what was retargeting every mouse
        // click's `event.target` to the track, meaning
        // `event.target.closest('video')` could never find a video -
        // reading the real target here instead, before capture takes
        // effect, sidesteps that entirely.
        downTarget = event.target;
        this.dragging = true;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(pointerId);
      });

      this.track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const delta = event.clientX - startX;
        moved = Math.abs(delta);
        this.offset = startOffset + delta;
        this.render();
      });

      // Tap-vs-drag disambiguation: a pointerdown/up with negligible
      // movement is a tap (toggle that video's play/pause state, or start
      // it if settings.click_to_play hasn't been triggered yet); anything
      // past the threshold was a drag, so it shouldn't also act on
      // whatever the finger/cursor happened to start on.
      //
      // Handled here rather than via a native 'click' listener on the
      // video/play-button themselves for mouse parity: this.track's own
      // setPointerCapture(pointerId) above retargets the eventual native
      // 'click' event to the track itself for mouse (touch's *implicit*
      // capture doesn't do this - see the comment above), so a listener
      // bound directly to the video or the play button would only ever
      // fire for touch, never mouse. Reading downTarget (captured before
      // that retargeting takes effect) sidesteps it entirely, and doing
      // so at the `.media-carousel__item` level - not just the <video> or
      // the icon - is also what makes the whole tile clickable/tappable,
      // not only the play button graphic itself.
      const endDrag = (event) => {
        if (event.pointerId !== pointerId) return;
        pointerId = null;
        this.dragging = false;
        this.track.classList.remove('is-dragging');

        if (moved > 10) {
          this.pauseThenResume();
        } else if (event.type === 'pointerup') {
          // Not on pointercancel - an interrupted gesture (e.g. the
          // browser taking over for a system gesture) shouldn't be
          // treated as a completed tap.
          const item = downTarget?.closest('.media-carousel__item');
          const video = item?.querySelector('video[data-carousel-media]');
          if (!video) return;

          if (!video.dataset.mediaLoaded) {
            // click_to_play: load + play + unmute in one deliberate
            // action. Otherwise (the rare case of a tap landing before
            // this item's own visibility-triggered load has fired):
            // just load + play, same as autoplay would have - these
            // decorative tiles were never audio-capable to begin with,
            // so a stray early tap shouldn't grant audio that a normal
            // autoplay-triggered load never would have either.
            if (this.dataset.clickToPlay === 'true') {
              this.startVideo(video);
            } else {
              this.loadVideo(video);
            }
          } else {
            this.togglePlayback(video);
          }
        }
      };

      this.track.addEventListener('pointerup', endDrag);
      this.track.addEventListener('pointercancel', endDrag);
    }

    setupArrows() {
      const prevButton = this.querySelector('[data-carousel-prev]');
      const nextButton = this.querySelector('[data-carousel-next]');

      const itemStep = (direction) => {
        const items = Array.from(this.track.querySelectorAll('.media-carousel__item'));
        const edge = this.getBoundingClientRect().left;
        const boundaries = items.map((item) => item.getBoundingClientRect().left - edge);
        const candidates = boundaries.filter((distance) => direction < 0 ? distance > 1 : distance < -1);
        if (candidates.length) return Math.min(...candidates.map(Math.abs));
        const first = items[0];
        return first ? first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0) : 300;
      };

      const stepBy = (direction) => {
        this.track.classList.add('is-stepping');
        this.offset += direction * itemStep(direction);
        this.render();
        this.pauseThenResume();
        window.setTimeout(() => this.track.classList.remove('is-stepping'), 300);
      };

      // "Previous" moves content right (offset increases), "next" moves
      // content left (offset decreases) - same direction convention as
      // the auto-play loop above.
      prevButton?.addEventListener('click', () => stepBy(1));
      nextButton?.addEventListener('click', () => stepBy(-1));
    }

    // The tap/click gesture on an already-loaded video - play/pause only,
    // not audio (see activateAudio() below for the one deliberate
    // audio-on trigger, the play button). Pausing already silences the
    // video on its own, so there's nothing extra to mute here.
    togglePlayback(video) {
      if (video.paused) {
        video.play().catch(() => {
          // Same rationale as loadVideo()'s finishLoad() - browser
          // autoplay policy can still reject this in edge cases; nothing
          // more to do, the poster/last frame just stays visible.
        });
      } else {
        video.pause();
      }
    }

    // The one deliberate "gain audio" action - called from
    // setupPlayButtons() below when a visitor clicks a video's play
    // button. Deactivates whatever else had audio (only one video across
    // the carousel, and the whole page via TendedAudioCoordinator, may
    // have audio at a time).
    activateAudio(video) {
      if (this.activeAudioVideo && this.activeAudioVideo !== video) {
        this.setAudioActive(this.activeAudioVideo, false);
      }
      this.setAudioActive(video, true);
      this.activeAudioVideo = video;
    }

    setAudioActive(video, active) {
      video.muted = !active;
      const item = video.closest('.media-carousel__item');
      if (item) item.toggleAttribute('data-audio-active', active);

      if (active) {
        window.TendedAudioCoordinator.activate(video, () => this.setAudioActive(video, false));
      } else if (window.TendedAudioCoordinator.active?.video === video) {
        window.TendedAudioCoordinator.active = null;
      }
    }

    // A video auto-PAUSES (not mutes - see the note below on why that
    // changed) the instant it's fully out of the carousel's own visible
    // window (root: this, the overflow:hidden clipping element) - not the
    // page/browser viewport, and not on partial visibility (threshold: 0
    // only fires at the fully-in/fully-out crossing). This is about items
    // scrolling past *within* the carousel's own track (driven by the
    // marquee's own continuous auto-scroll in startLoop() - it never
    // stops on its own, so this fires routinely, not just on user drags),
    // not the carousel itself leaving the page - see
    // setupSectionExitAutoPause() below for that separate case.
    //
    // Pausing here, not muting: this used to call setAudioActive(...,
    // false) and null out this.activeAudioVideo, which silently and
    // permanently stripped the "committed to audio-on until paused" state
    // from togglePlayback()/activateAudio() - since resuming via a tap
    // only ever calls video.play()/pause(), never activateAudio() again,
    // a video muted this way had no way back to audio short of a full
    // restart (impossible once the play button is gone). A paused video
    // makes no sound regardless of its muted flag, so pausing is just as
    // effective a safety net while it's off-screen, but - unlike muting -
    // it leaves the video's own unmuted state and this.activeAudioVideo
    // intact, so a later deliberate tap-to-resume genuinely resumes with
    // sound, matching the documented interaction model at the top of this
    // file.
    setupIntersectionAutoPause() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.target === this.activeAudioVideo) {
              entry.target.pause();
            }
          });
        },
        { root: this, threshold: 0 }
      );

      this.videoExitObserver = observer;
      this.querySelectorAll('video').forEach((video) => observer.observe(video));
    }

    // Separate trigger from setupIntersectionAutoPause() above: pauses
    // whichever video currently has audio the instant the WHOLE carousel
    // section scrolls out of the page viewport (default root, not root:
    // this) - e.g. the visitor keeps scrolling down the page past this
    // section entirely, rather than an item merely sliding past within
    // the track. Pauses rather than mutes for the same reason as above -
    // preserves the committed audio-on state for when the visitor
    // scrolls back and taps to resume, instead of silently and
    // permanently stripping it. Never auto-*plays* anything - the
    // carousel's own videos only ever gain audio via an explicit
    // play-button click (see activateAudio()/setupPlayButtons()).
    setupSectionExitAutoPause() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && this.activeAudioVideo) {
              this.activeAudioVideo.pause();
            }
          });
        },
        { threshold: 0 }
      );

      this.sectionExitObserver = observer;
      observer.observe(this);
    }
  }

  if (!customElements.get('media-carousel')) {
    customElements.define('media-carousel', MediaCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-text"] && !Shopify.designMode) return;
  try {
    
  // See sections/media-carousel.liquid for these shared singletons/module -
  // defined identically (guarded) there, in sections/hero.liquid, and
  // here, so all three compile in any order.
  // window.TendedAudioCoordinator enforces "only one video's audio active
  // across the whole page at a time"; window.TendedPauseCoordinator is a
  // separate, stricter rule - only one video PLAYING at all, anywhere on
  // the site, no exceptions (a paused video is always silent, but a
  // silent video isn't necessarily paused, which is why these are two
  // coordinators, not one); window.TendedVideoUX wires the shared
  // play/pause icon, buffer bar, and spinner for
  // snippets/video-controls.liquid's markup; window.TendedMediaPreload is
  // the priority queue that lets this section's video preload win over
  // the carousel's regardless of DOM order.
  window.TendedAudioCoordinator = window.TendedAudioCoordinator || {
    active: null,
    activate(video, deactivate) {
      if (this.active && this.active.video !== video) {
        this.active.deactivate();
      }
      this.active = { video, deactivate };
    },
  };

  window.TendedPauseCoordinator = window.TendedPauseCoordinator || {
    active: null,
    activate(video) {
      if (this.active && this.active !== video && !this.active.paused) {
        this.active.pause();
      }
      this.active = video;
    },
  };

  window.TendedVideoUX = window.TendedVideoUX || {
    wireVideo(video, wrapper) {
      this.setupPlayPauseIcon(video, wrapper);
      this.setupBufferBar(video, wrapper);
      this.setupSpinner(video, wrapper);
      this.registerForPauseCoordination(video);
    },

    setupPlayPauseIcon(video, wrapper) {
      const button = wrapper.querySelector('[data-video-play-button]');
      if (!button) return;

      video.addEventListener('play', () => button.classList.add('is-hidden'));
      video.addEventListener('pause', () => button.classList.remove('is-hidden'));
    },

    setupBufferBar(video, wrapper) {
      const bar = wrapper.querySelector('[data-video-buffer-bar]');
      if (!bar) return;

      const fill = bar.querySelector('[data-video-buffer-fill]');
      const FULLY_BUFFERED_THRESHOLD = 0.995;

      const bufferedRatio = () => {
        if (!video.buffered.length || !video.duration) return 0;
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        return Math.min(1, bufferedEnd / video.duration);
      };

      const updateFill = () => {
        const ratio = bufferedRatio();
        if (fill) fill.style.width = `${ratio * 100}%`;
        bar.classList.toggle('is-visible', ratio < FULLY_BUFFERED_THRESHOLD);
      };

      const markReceiving = () => {
        bar.classList.remove('is-stalled');
        updateFill();
      };

      video.addEventListener('progress', markReceiving);
      video.addEventListener('waiting', () => bar.classList.add('is-stalled'));
      video.addEventListener('canplay', markReceiving);

      updateFill();
    },

    setupSpinner(video, wrapper) {
      const spinner = wrapper.querySelector('[data-video-spinner]');
      if (!spinner) return;

      video.addEventListener('waiting', () => spinner.classList.add('is-visible'));
      video.addEventListener('playing', () => spinner.classList.remove('is-visible'));
      video.addEventListener('pause', () => spinner.classList.remove('is-visible'));
    },

    registerForPauseCoordination(video) {
      video.addEventListener('play', () => {
        window.TendedPauseCoordinator.activate(video);
      });
    },
  };

  window.TendedMediaPreload = window.TendedMediaPreload || {
    queue: [],
    register(priority, fn) {
      this.queue.push({ priority, fn });
    },
    flush() {
      this.queue.sort((a, b) => a.priority - b.priority);
      this.queue.forEach(({ fn }) => fn());
      this.queue = [];
    },
  };

  if (!window.TendedMediaPreloadListenerAdded) {
    window.TendedMediaPreloadListenerAdded = true;
    window.addEventListener('load', () => window.TendedMediaPreload.flush(), { once: true });
  }

  class MediaTextBlock extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-media-text-video]');
      if (!this.video) return;

      // Play INTENT, tracked separately from actually calling .play() -
      // set true/false purely by the visibility threshold in
      // setupVisibilityBehavior() below, regardless of whether the video
      // has any real source yet. attemptPlay() is the only thing that
      // ever consults it, and gets called again once the video actually
      // becomes ready (see the 'loadedmetadata' listener below) - so a
      // threshold crossing that happens before the deferred media has
      // loaded isn't lost, it just gets acted on once loading catches up
      // instead of failing silently at the moment of crossing.
      this.shouldPlay = false;

      const wrapper = this.querySelector('.media-text__video-wrap');
      if (wrapper) window.TendedVideoUX.wireVideo(this.video, wrapper);

      this.setupTapToggle();
      this.setupVisibilityBehavior();
      this.setupRestartButton();
      this.setupFit();

      // Redundant with the attemptPlay() call already inside
      // loadDeferredMedia() (below) for the common case, but covers a
      // subtler one: calling .play() synchronously right after .load()
      // (as loadDeferredMedia() does) can be unreliable on some mobile
      // browsers if playback doesn't actually start before that .play()
      // call resolves/rejects - retrying once 'loadedmetadata' genuinely
      // fires (videoWidth/videoHeight non-zero, real readiness rather
      // than "we just asked it to load") catches that case too.
      this.video.addEventListener('loadedmetadata', () => this.attemptPlay());

      // Priority 0 - always registered ahead of the carousel's priority 1,
      // so this section's fetch is issued first on window 'load' no matter
      // which section appears first in the DOM (there's only ever one
      // media-text section per page, so this doesn't need to coordinate
      // with any other instance of itself).
      if (document.readyState === 'complete') {
        this.loadDeferredMedia();
      } else {
        window.TendedMediaPreload.register(0, () => this.loadDeferredMedia());
      }
    }

    loadDeferredMedia() {
      this.video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      this.video.preload = 'auto';
      this.video.load();
      this.attemptPlay();
    }

    // Only ever calls .play() when the visibility threshold has actually
    // been crossed (this.shouldPlay) - separating "do we WANT this video
    // playing" from "did we just successfully call .play()" is what lets
    // a threshold crossing that happens before the video has a real
    // source yet (data-src is still deferred - see loadDeferredMedia())
    // get honored later instead of silently dropped: nothing here needs
    // to know WHY it's being called again, it just re-checks the current
    // intent every time.
    attemptPlay() {
      if (!this.shouldPlay) return;
      this.video.play().catch(() => {
        // Autoplay can still be blocked by browser policy even for a muted
        // video in some edge cases - the poster image stays visible either
        // way, so there's nothing more to do here (same as the carousel).
      });
    }

    setAudioActive(active) {
      this.video.muted = !active;

      if (active) {
        window.TendedAudioCoordinator.activate(this.video, () => this.setAudioActive(false));
      } else if (window.TendedAudioCoordinator.active?.video === this.video) {
        window.TendedAudioCoordinator.active = null;
      }
    }

    // A tap/click toggles ONLY play/pause - it does not touch mute at all
    // (matches the carousel/hero's togglePlayback() model). Audio here is
    // driven entirely by setupVisibilityBehavior() below, not by this
    // gesture - previously this handler bundled mute+play together,
    // which meant tapping to pause also permanently silenced the video
    // with no way back short of scrolling out and back in.
    setupTapToggle() {
      this.video.addEventListener('click', () => {
        if (this.video.paused) {
          this.shouldPlay = true;
          this.attemptPlay();
        } else {
          this.shouldPlay = false;
          this.video.pause();
        }
      });
    }

    // Observes the <video> element itself, not the section wrapper -
    // rooted at the page viewport (default root), but the target matters:
    // on mobile the heading/body text stacks above or below the video
    // rather than beside it, so the section's own bounding box can be
    // taller than (and positioned differently from) the video's actual
    // visible area. Watching the section itself made the trigger fire too
    // early/late relative to when the video was really on screen -
    // watching the video directly fixes that on both mobile and desktop
    // with the same logic, no breakpoint-specific thresholds needed.
    //
    // A single threshold: 0 (fully-in/out crossing) fires the instant even
    // a 1px sliver of the section is visible at the screen edge, while the
    // previous section is still mostly on screen - too eager. Using two
    // thresholds (0.25 and 0.75) instead creates a hysteresis band: once
    // active, the video stays active until intersectionRatio drops back to
    // 0.25 or below; once inactive, it stays inactive until the ratio
    // climbs to 0.75 or above. The dead zone between 0.25 and 0.75 doesn't
    // toggle anything either way, so there's no flapping right at a
    // section boundary. This works symmetrically for both scroll
    // directions with no separate direction-tracking needed - the
    // observer fires on every threshold crossing regardless of which way
    // the ratio is moving, and each callback just checks where the ratio
    // landed.
    //
    // Also drives play/pause, not just mute/unmute: play()/pause() on an
    // already-loaded video resume/halt from wherever currentTime already
    // is - neither call resets position, so scrolling back into view
    // continues right where playback left off. Sets this.shouldPlay
    // rather than calling .video.play() directly - see attemptPlay() for
    // why (the video may not have a real source yet at the moment the
    // threshold crosses).
    //
    // Exiting only pauses now, not mutes - pausing already silences the
    // video regardless of its muted flag, and muting here on top of that
    // (the previous behavior) permanently stripped the "resume with
    // sound" state with no way back, since nothing else in this file ever
    // re-unmutes except this same enter branch - same bug already fixed
    // in the carousel's own exit-pause handlers.
    setupVisibilityBehavior() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio >= 0.75) {
              this.setAudioActive(true);
              this.shouldPlay = true;
              this.attemptPlay();
            } else if (entry.intersectionRatio <= 0.25) {
              this.shouldPlay = false;
              this.video.pause();
            }
          });
        },
        { threshold: [0.25, 0.75] }
      );

      observer.observe(this.video);
    }

    // Restarts from the beginning without touching mute state - separate
    // control from the click-to-toggle-audio behavior above (the button
    // sits outside the <video> element itself, so it never bubbles into
    // setupClickToggle()'s listener).
    setupRestartButton() {
      const button = this.querySelector('[data-media-text-restart]');
      if (!button) return;

      button.addEventListener('click', () => {
        this.video.currentTime = 0;
        this.video.play().catch(() => {});
      });
    }

    // Shrink-to-fit, never crop: fits the video within BOTH the available
    // column width and the available viewport height (below the sticky
    // header) at once, preserving aspect ratio - same "shrink to fit,
    // don't crop" philosophy as the product page's sticky gallery column
    // (updateGalleryFit() in sections/product.liquid). Sets explicit
    // width AND height directly (never width: auto; height: auto) - see
    // the long comment on .media-text__video-wrap video in the
    // stylesheet above for why relying on the browser's own
    // replaced-element auto-sizing was the actual cause of a persistent
    // resize-after-playback-starts bug. The aspect ratio comes from
    // data-aspect-ratio (set inline from Liquid - see the <video> tag
    // above), NOT from the video element's own videoWidth/videoHeight,
    // so this never depends on whether/when the browser has established
    // the video's real intrinsic dimensions - it can run immediately on
    // connect, no metadata-readiness gating needed at all.
    setupFit() {
      const aspectRatio = parseFloat(this.video.dataset.aspectRatio) || 16 / 9;
      const mediaColumn = this.querySelector('.media-text__media');

      const update = () => {
        const headerHeight =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        const availableHeight = Math.max(0, window.innerHeight - headerHeight);
        const availableWidth = mediaColumn ? mediaColumn.clientWidth : window.innerWidth;

        const widthIfHeightConstrained = availableHeight * aspectRatio;
        const targetWidth = Math.max(0, Math.min(availableWidth, widthIfHeightConstrained));
        const targetHeight = targetWidth / aspectRatio;

        this.video.style.width = `${targetWidth}px`;
        this.video.style.height = `${targetHeight}px`;
      };

      window.addEventListener('resize', update);
      window.addEventListener('orientationchange', update);
      update();
    }
  }

  if (!customElements.get('media-text-block')) {
    customElements.define('media-text-block', MediaTextBlock);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-library"]) return;
  try {
    
  (() => {
    function openPopup(id, opener) {
      const popup = document.getElementById(id);
      if (!(popup instanceof HTMLDialogElement) || !popup.matches('.theme-popup')) return false;
      document.querySelectorAll('.theme-popup[open]').forEach((other) => {
        if (other !== popup) other.close();
      });
      popup.popupOpener = opener;
      if (!popup.open) popup.showModal();
      return true;
    }

    document.addEventListener('tended:popup-open', (event) => {
      if (openPopup(event.detail.id, event.detail.opener)) event.preventDefault();
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash.startsWith('#popup-')) return;
      if (openPopup(url.hash.slice(1), link)) event.preventDefault();
    });

    document.addEventListener('click', (event) => {
      const popup = event.target.closest('.theme-popup');
      if (!popup) return;
      if (event.target.closest('[data-popup-close]')) popup.close();
      if (event.target === popup) {
        const rect = popup.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) popup.close();
      }
    });

    document.addEventListener('close', (event) => {
      if (!event.target.matches?.('.theme-popup')) return;
      const opener = event.target.popupOpener;
      if (opener?.isConnected) opener.focus();
    }, true);

    document.addEventListener('shopify:block:select', (event) => {
      const definition = event.target.closest('[data-popup-definition]');
      const popup = definition?.querySelector('.theme-popup');
      if (popup) openPopup(popup.id);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.theme-popup[open]').forEach((popup) => popup.close());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function groupProductPageColumns() {
    const productPage = document.querySelector('.product-page');
    if (!productPage || productPage.dataset.columnsGrouped) return;

    const blocks = Array.from(productPage.children).filter((el) => el.classList.contains('shopify-block'));
    const galleryBlock = blocks.find((el) => el.querySelector('.media-gallery'));
    if (!galleryBlock) return;

    const infoColumn = document.createElement('div');
    infoColumn.className = 'product-page__info-column';
    productPage.insertBefore(infoColumn, galleryBlock.nextSibling);

    blocks.forEach((block) => {
      if (block !== galleryBlock) infoColumn.appendChild(block);
    });

    productPage.dataset.columnsGrouped = 'true';
  }

  groupProductPageColumns();

  // The theme editor replaces this section's DOM whenever a setting
  // changes, which would otherwise undo the grouping above (blocks would
  // render back as flat siblings). Re-run on every section reload - the
  // dataset guard prevents double-grouping an already-grouped page.
  document.addEventListener('shopify:section:load', groupProductPageColumns);

  // Desktop-only: shrinks the gallery column's width (see the doc comment
  // at the top of this file) whenever its default 60% share would render
  // taller than the viewport - never skips pinning as a fallback. Always
  // measures from the DEFAULT width first (clearing any previous
  // override), since the calculation needs to know how tall the gallery
  // WOULD be at full size, not whatever shrunk width a prior pass left in
  // place.
  function updateGalleryFit() {
    const productPage = document.querySelector('.product-page');
    if (!productPage) return;

    productPage.style.removeProperty('--product-gallery-col-width');

    if (window.innerWidth < 750) return;

    const galleryWrap = productPage.querySelector(':scope > .shopify-block:has(.media-gallery)');
    const slide = galleryWrap?.querySelector('.media-gallery__slide');
    if (!galleryWrap || !slide) return;

    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 60;
    const availableHeight = window.innerHeight - headerHeight;

    const wrapWidth = galleryWrap.offsetWidth;
    const wrapHeight = galleryWrap.offsetHeight;
    const slideHeight = slide.offsetHeight;

    if (wrapHeight <= availableHeight) return;

    // The thumbnail strip/indicator/gaps below the main image stay a
    // fixed height regardless of column width - only the square main
    // image (aspect-ratio: 1/1) scales with it. So shrinking the whole
    // gallery to fit is just: give the image whatever height remains
    // after that fixed chrome, then carry over whatever fixed gap
    // already existed between the wrap's width and the image's own
    // width (e.g. block padding, if any set).
    const chromeHeight = wrapHeight - slideHeight;
    const targetSlideHeight = Math.max(0, availableHeight - chromeHeight);
    const targetWrapWidth = targetSlideHeight + (wrapWidth - slideHeight);

    // Floor keeps a pathologically short viewport from collapsing the
    // gallery to an unusable sliver - it'll simply exceed the viewport
    // height a little in that extreme case rather than disappear.
    productPage.style.setProperty('--product-gallery-col-width', `${Math.max(200, targetWrapWidth)}px`);
  }

  // Only the viewport's own dimensions (and the header height, which
  // changes together with it) actually affect whether the gallery fits -
  // its own chrome (thumbnail strip, indicator) is CSS/aspect-ratio
  // driven, not content-driven, so it doesn't shift on its own once
  // rendered. A ResizeObserver on the gallery wrap itself was considered
  // and deliberately avoided here: this function both reads AND writes
  // that same element's width (clearing the override to measure, then
  // re-applying it), which would make the wrap its own resize trigger -
  // a plain `resize` listener sidesteps that risk entirely.
  function initGalleryFitObserver() {
    const productPage = document.querySelector('.product-page');
    if (!productPage || productPage.dataset.galleryFitBound) return;
    productPage.dataset.galleryFitBound = 'true';

    window.addEventListener('resize', updateGalleryFit);
    updateGalleryFit();
  }

  initGalleryFitObserver();

  // The theme editor swaps in a brand-new .product-page element on every
  // section reload, so it naturally arrives without the galleryFitBound
  // flag already set - no manual reset needed, unlike the dataset guard
  // pattern above which reuses the same persistent DOM node.
  document.addEventListener('shopify:section:load', initGalleryFitObserver);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  function formatMoney(cents, format) {
    const value = Number(cents) || 0;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      if (isNaN(number)) return '0';

      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const cents_ = parts[1] ? decimal + parts[1] : '';

      return dollars + cents_;
    }

    // Built without a literal double-brace fallback in the source - the
    // theme linter flags double-brace-looking text inside a script block
    // as accidental Liquid, even inside a plain JS string.
    const dollarSign = String.fromCharCode(36);
    const openBrace = String.fromCharCode(123, 123);
    const closeBrace = String.fromCharCode(125, 125);
    const defaultFormat = dollarSign + openBrace + 'amount' + closeBrace;
    const activeFormat = format || defaultFormat;

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = activeFormat.match(placeholderRegex);
    let formatted;

    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatWithDelimiters(value, 2, "'", '.');
        break;
      default:
        formatted = formatWithDelimiters(value, 2);
    }

    return match ? activeFormat.replace(placeholderRegex, formatted) : dollarSign + formatted;
  }

  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.submitButton = this.querySelector('[data-buy-bar-submit]');
      this.priceEl = this.querySelector('[data-buy-bar-price]');
      this.errorEl = this.querySelector('[data-buy-bar-error]');
      this.hasBundleSelector = Boolean(document.querySelector('bundle-selector'));
      this.isSubmitting = false;

      this.items = this.submitButton
        ? [{ id: Number(this.submitButton.dataset.variantId), quantity: 1 }]
        : [];
      this.available = Boolean(this.submitButton) && !this.submitButton.disabled;

      document.addEventListener('variant:change', (event) => this.onVariantChange(event.detail));
      document.addEventListener('bundle:change', (event) => this.onBundleChange(event.detail));

      if (this.submitButton) {
        this.submitButton.addEventListener('click', () => this.addToCart());
      }

      this.reserveBottomSpace();
      this.initScrollVisibility();
    }

    // Reserves space at the bottom of the page equal to the bar's own
    // height, permanently from page load - not just while the bar is
    // visible. Toggling this on/off reactively (only once the bar becomes
    // visible) doesn't work: by the time a scroll event fires and adds the
    // padding, the browser has already clamped the user's scroll position
    // to the OLD (pre-padding) max scrollable distance, so reaching the
    // bottom of the page and stopping - the natural thing to do - lands
    // the user exactly in the overlap, since the newly-reserved space is
    // below their current viewport and nothing pushes them into it.
    // Reserving it upfront means it's baked into scrollHeight before the
    // user ever gets near the bottom.
    //
    // Also accounts for the bar's own `bottom` offset (it floats above the
    // viewport edge as a centered island now, not flush against it) plus a
    // fixed extra gap, so footer content - in particular the payment-icon
    // row (sections/footer.liquid's show_payment_icons) - doesn't end up
    // sitting flush against the bar with zero breathing room once scrolled
    // into view. Reads the offset via getComputedStyle rather than
    // hardcoding it a second time here, so this can't silently drift out
    // of sync with the CSS `bottom` value above.
    //
    // Sets a CSS custom property on <html> rather than body.style.paddingBottom
    // directly - sections/footer.liquid's own padding-bottom rule adds this
    // var on top of its own configured spacing, so the reserved space is
    // structurally part of the footer element itself. That way a footer
    // background color paints all the way through it (no separate blank
    // gap between the colored footer and this reserved space) - setting
    // it on body instead left a gap no background could reach, since it
    // wasn't part of any section's own box.
    reserveBottomSpace() {
      const bottomOffset = parseFloat(getComputedStyle(this).bottom) || 0;
      const footerGap = 20;
      const reserved = this.offsetHeight + bottomOffset + footerGap;
      document.documentElement.style.setProperty('--sticky-bar-reserved-space', `${reserved}px`);
    }

    initScrollVisibility() {
      const threshold = 10;
      let lastScrollY = window.scrollY;
      let ticking = false;
      const el = this;

      // Compares each frame only against the immediately preceding one,
      // matching sections/header.liquid's sticky logic - see that file for
      // why this is simpler and more reliable than freezing an anchor point
      // until a threshold is crossed.
      function update() {
        const currentScrollY = window.scrollY;
        const delta = currentScrollY - lastScrollY;

        if (currentScrollY <= threshold) {
          el.setVisible(false);
        } else if (delta > threshold) {
          el.setVisible(true);
        } else if (delta < -threshold) {
          el.setVisible(false);
        }

        lastScrollY = currentScrollY;
        ticking = false;
      }

      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
          }
        },
        { passive: true }
      );
    }

    setVisible(visible) {
      this.classList.toggle('is-visible', visible);
    }

    onVariantChange(detail) {
      if (this.hasBundleSelector) return;

      if (detail.variantId) {
        this.items = [{ id: detail.variantId, quantity: 1 }];
      }
      this.setAvailable(Boolean(detail.variantId) && Boolean(detail.available));
    }

    onBundleChange(detail) {
      this.items = detail.items || [];

      if (this.priceEl && typeof detail.totalPriceCents === 'number') {
        this.priceEl.textContent = formatMoney(detail.totalPriceCents, this.dataset.moneyFormat);
      }

      this.setAvailable(Boolean(detail.available) && this.items.length > 0);
    }

    setAvailable(available) {
      this.available = available;
      this.classList.toggle('is-sold-out', !available);
      if (this.submitButton) {
        this.submitButton.disabled = !available;
        this.submitButton.textContent = available
          ? this.dataset.availableLabel
          : this.dataset.soldOutLabel;
      }
    }

    async addToCart() {
      if (!this.available || !this.items.length || this.isSubmitting) return;

      this.isSubmitting = true;
      this.submitButton.disabled = true;
      this.submitButton.textContent = this.dataset.addingLabel || this.dataset.availableLabel;
      if (this.errorEl) this.errorEl.hidden = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: this.items }),
        });

        if (!response.ok) {
          const body = await response.json().catch(() => null);
          throw new Error((body && body.description) || this.dataset.errorLabel);
        }

        await this.refreshCartCount();
        document.querySelector('cart-drawer')?.open();

        this.isSubmitting = false;
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.dataset.availableLabel;
      } catch (error) {
        this.isSubmitting = false;
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.dataset.availableLabel;
        if (this.errorEl) {
          this.errorEl.textContent = error.message || this.dataset.errorLabel;
          this.errorEl.hidden = false;
        }
      }
    }

    // The page no longer navigates to /cart on a successful add, so the
    // header cart-count badge has to be refreshed client-side instead.
    // Creates the badge element if the cart was previously empty (Liquid
    // only renders it when cart.item_count > 0, so a first-ever
    // add-to-cart has no existing badge to update).
    async refreshCartCount() {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`);
      const cart = await response.json();
      const cartLink = document.querySelector('.site-header__cart');
      let badge = document.querySelector('.site-header__cart-count');

      if (cart.item_count > 0) {
        if (!badge && cartLink) {
          badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          cartLink.prepend(badge);
        }
        if (badge) badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    }
  }

  if (!customElements.get('sticky-buy-bar')) {
    customElements.define('sticky-buy-bar', StickyBuyBar);
  }

  } catch(e) { console.error(e); }
})();
})();
